import gql from 'graphql-tag';

export const nsRegisterFcmToken = gql`
  mutation nsRegisterFcmToken($token: String!) {
    nsRegisterFcmToken(token: $token) {
      code
      success
      message
    }
  }
`;

export const nsUnregisterFcmToken = gql`
  mutation nsUnregisterFcmToken($token: String!) {
    nsUnregisterFcmToken(token: $token) {
      code
      success
      message
    }
  }
`;
